import React from 'react';
import PropTypes from 'prop-types';

import '../../utils/styles/Modal.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

function Modal({ open, onClose, children }) {
    return (
        <>
            {open && (
                <div className="modal-overlay" onClick={onClose}>
                    <div className="modal">
                        <button className="modal-close-btn" onClick={onClose}>
                            <FontAwesomeIcon icon={faXmark} size="xl" />
                        </button>
                        <div className="modal-content">{children}</div>
                    </div>
                </div>
            )}
        </>
    );
}

Modal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default Modal;
